/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type EventRewardResponse = {
    /**
     * Reward ID
     */
    id: string;
    /**
     * Event ID
     */
    eventId: string;
    /**
     * Starting position for this reward
     */
    positionStart: number;
    /**
     * Ending position for this reward
     */
    positionEnd: number;
    /**
     * Type of reward
     */
    rewardType: EventRewardResponse.rewardType;
    /**
     * Item ID for item rewards
     */
    itemId?: string | null;
    /**
     * Number of case tokens for case token rewards
     */
    caseTokens?: number | null;
    /**
     * Item name (only for item rewards)
     */
    itemName?: string | null;
    /**
     * Item image URL (only for item rewards)
     */
    itemImage?: string | null;
    /**
     * Item price in cents (only for item rewards)
     */
    itemPrice?: number | null;
    /**
     * Item rarity color (only for item rewards)
     */
    itemColor?: string | null;
    createdAt: string;
    updatedAt: string;
};
export namespace EventRewardResponse {
    /**
     * Type of reward
     */
    export enum rewardType {
        ITEM = 'item',
        CASE_TOKEN = 'case_token',
    }
}

